var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueMarkdownPlus',{attrs:{"html":false,"anchorAttributes":_vm.anchorAttributes,"source":_vm.$t(`help.faq.items[${_vm.index}].answer`, _vm.contentAttributes)}})
}
var staticRenderFns = []

export { render, staticRenderFns }